import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ax from '../config';
import { openNotification } from 'src/components/helpers/notification';


const initialState = {
    authToken: null,
    usersList: null,
    usersListLoading: null,
    rolesList: null,
    rolesListLoading: null,
    myInfo: null,
    roleInfo: null
};


export const authLogin = createAsyncThunk('auth/login', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.post('/api/account/authorization', payload)
        let tokens = data.data.value
        if (tokens.accessToken && tokens.accessTokenRefresh) {
            localStorage.setItem('accessToken', tokens.accessToken)
            localStorage.setItem('accessTokenRefresh', tokens.accessTokenRefresh)
            dispatch(setAuthToken(tokens.accessToken))
            openNotification({
                type: 'success',
                message: 'Успешный вход в приложение'
            })
            window.location.href = '/clients'
        }
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const deleteUser = createAsyncThunk('auth/delete', async (payload) => {
    try {
        const { data } = await ax.delete(`/api/account/manager?userId=${payload.userId}&nextUserId=${payload.nextUserId}`)
        data && openNotification({
            type: 'success',
            message: `Пользователь успешно удален`
        })
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const authRegister = createAsyncThunk('auth/register', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.post('/api/account/register', payload)
        data && openNotification({
            type: 'success',
            message: `Пользователь успешно зарегистрирован`
        })
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const editUser = createAsyncThunk('auth/edit', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.post('/api/account/users', payload)
        data && openNotification({
            type: 'success',
            message: `Пользователь успешно отредактирован`
        })
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const activatorUser = createAsyncThunk('auth/activatorUser', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.post('/api/account/activation', payload)
        // data && openNotification({
        //     type: 'success',
        //     message: `Пользователь успешно ${payload.active ? 'активирован' : 'деактивирован'}`
        // })
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const refreshAuthToken = createAsyncThunk('refreshAuthToken', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.get('/api/account/account/RefreshToken', payload)
        let tokens = data
        
        if (tokens.accessToken && tokens.accessTokenRefresh) {
            localStorage.setItem('accessToken', tokens.accessToken)
            localStorage.setItem('accessTokenRefresh', tokens.accessTokenRefresh)
            dispatch(setAuthToken(tokens.accessToken))
        }
    } catch (error) {
        return error
    }
})

export const getUsers = createAsyncThunk('getUsers', async (payload, { dispatch }) => {
    try {
        dispatch(setUsersListLoading(true))
        const { data } = await ax.get('/api/account/users', { params: payload })
        data && dispatch(setUsersListLoading(false))
        return data
    } catch (error) {
        dispatch(setUsersListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const getRoles = createAsyncThunk('getRoles', async (payload, { dispatch }) => {
    try {
        dispatch(setRolesListLoading(true))
        const { data } = await ax.get('/api/account/roles', { params: payload })
        data && dispatch(setRolesListLoading(false))
        return data
    } catch (error) {
        dispatch(setRolesListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const getMyInfo = createAsyncThunk('getMyInfo', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.get('/api/account/myInfo', { params: payload })
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const rolesAction = createAsyncThunk('rolesAction', async (payload, { dispatch }) => {
    dispatch(setRolesListLoading(true))
    try {
        let data;
        const url = '/api/account/roles';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setRolesListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Роль успешно отредактирована`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Роль успешно добавлена`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Роль успешно удалена`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setRolesListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

export const getRoleInfo = createAsyncThunk('getRoleInfo', async (payload, { dispatch }) => {
    try {
        debugger
        const { data } = await ax.get('/api/account/roleInfo', { params: payload })
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})



const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {

        setAuthToken: (state, action) => {
            state.authToken = action.payload
        },
        setUsersListLoading: (state, action) => {
            state.usersListLoading = action.payload
        },
        setRolesListLoading: (state, action) => {
            state.rolesListLoading = action.payload
        }

    },
    extraReducers: (builder) => {
        builder.addCase(getUsers.fulfilled, (state, action) => {
            state.usersList = action.payload
        }),
        builder.addCase(rolesAction.fulfilled, (state, action) => {
            state.rolesList = action.payload
        }),
        builder.addCase(getMyInfo.fulfilled, (state, action) => {
            state.myInfo = action.payload
        }),
        builder.addCase(getRoleInfo.fulfilled, (state, action) => {
            state.roleInfo = action.payload
        })
    }
});

export const { setAuthToken, setUsersListLoading, setRolesListLoading } = AuthSlice.actions;

export default AuthSlice.reducer